// In-app AI Help Assistant — shared constants (SPEC-v1 §7).

// Feature flag. CRA inlines process.env.REACT_APP_* at build time; default OFF.
// The help entry point mounts ONLY when this is exactly "true".
export const HELP_ASSISTANT_ENABLED =
  process.env.REACT_APP_AI_HELP_ASSISTANT === "true";

// Support fallback surfaced when the assistant can't answer (§7 "don't-know").
export const SUPPORT_EMAIL = "support@iyuga.net";

// The FAB's own fixed-position stacking layer (index.jsx's root Box). Deliberately
// far above ordinary content so the launcher is reachable from anywhere — but that
// means any OTHER floating UI anchored near the FAB's bottom-right corner (an open
// dropdown/kebab menu, say) must stack above this value too, or the FAB visually
// and functionally occludes it. Exported so those call sites derive from the same
// number instead of guessing a "big enough" one of their own (ISP-9999: the gallery
// kebab menu's old zIndex 9999 lost this stacking fight — measured live, an open
// menu's bottom-right corner sat under the FAB, and clicks there hit the FAB instead
// of the menu item).
export const HELP_FAB_Z_INDEX = 13000;

// Client-side screenshot cap (backend also enforces max 4).
export const MAX_IMAGES = 4;

// Max question length (backend rejects > 4000).
export const MAX_QUESTION_LENGTH = 4000;

// First-run greeting shown in the empty state.
export const GREETING =
  "Hi! I'm the iYuga Help Assistant. Ask me how to do anything in the app — building wheels, segments, subscriptions and more. You can attach a screenshot too.";

// Example prompts offered on first run (click to ask).
export const EXAMPLE_QUESTIONS = [
  "How do I add a segment to my wheel?",
  "How do I change my subscription?",
  "How do I share a wheel with someone?",
];
